import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents,
    MultiSetsMulticampaignPromotionStates,
} from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionRestoreState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    MultiSetsMulticampaignPromotionModuleEvents
> {
    public onEnterState(): void {
        if (this.isRestorePromotionAfterStartGame()) {
            this.emit('General.Flow.WAIT_EVENT_BEFORE_RESTORE_GAME', 'MultiSetsMulticampaignPromotion.START_STATE_LEFT');
        }
    }

    protected setupEvents(): void {
        if (this.isRestorePromotionAfterStartGame()) {
            this.setEventHandler('General.Flow.WAITING_OF_RESTORE_GAME', this.startPromotion.bind(this));
        } else {
            this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.startPromotion.bind(this));
        }
    }

    protected startPromotion(): void {
        this.module.gotoState(MultiSetsMulticampaignPromotionStates.START);
    }

    protected isRestorePromotionAfterStartGame(): boolean {
        return this.module.nextActionIsSpin || this.module.getPromotion().isActive();
    }

    public onLeaveState(): void {}
}
